import script from "./NumberConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./NumberConfirmation.vue?vue&type=style&index=0&id=3b16a4de&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b16a4de"]])

export default __exports__